const PETAL_ANGLES = [0, 45, 90, 135, 180, 225, 270, 315];

const Sunflower = () => (
  <g transform="translate(32 52.5)">
    {PETAL_ANGLES.map((a) => (
      <ellipse
        key={a}
        rx="1.5"
        ry="2.8"
        fill="#C18C3D"
        transform={`rotate(${a}) translate(0 -4.3)`}
      />
    ))}
    <circle r="2.1" fill="#A3562A" />
  </g>
);

export const Watermark = () => (
  <span
    data-testid="photo-watermark"
    className="absolute bottom-2.5 right-3 z-[8] pointer-events-none opacity-[0.22]"
    aria-hidden="true"
  >
    <svg viewBox="24 44.5 16 16" className="w-6 h-6" fill="none">
      <Sunflower />
    </svg>
  </span>
);

export const LogoMark = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <rect x="3" y="3" width="58" height="58" rx="12" stroke="#C18C3D" strokeWidth="2.5" />
    <path
      d="M27 12h4.5a7.5 4.5 0 0 1 0 9H27z"
      stroke="#C18C3D"
      strokeWidth="2.6"
      strokeLinejoin="round"
    />
    <path
      d="M18 45V26l14 15 14-15v19"
      stroke="#E6DFD3"
      strokeWidth="4.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Sunflower />
  </svg>
);

export const LogoDraw = ({ className = "w-20 h-20" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <rect x="3" y="3" width="58" height="58" rx="12" stroke="#C18C3D" strokeWidth="2" />
    <path
      d="M27 12h4.5a7.5 4.5 0 0 1 0 9H27z"
      stroke="#C18C3D"
      strokeWidth="2.6"
      strokeLinejoin="round"
    />
    <path
      d="M18 45V26l14 15 14-15v19"
      stroke="#E6DFD3"
      strokeWidth="4.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Sunflower />
  </svg>
);

export const Wordmark = ({ className = "" }) => (
  <span className={`font-display font-medium tracking-[0.35em] text-sm text-cream ${className}`}>
    DANI&nbsp;MORR
  </span>
);
